import { render, staticRenderFns } from "./SpeakStraight1Form.vue?vue&type=template&id=3a3f77b8&"
import script from "./SpeakStraight1Form.vue?vue&type=script&lang=js&"
export * from "./SpeakStraight1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports